import React, { useEffect } from "react";
import { Container, } from "react-bootstrap";
import { baseURL, headers } from "../../../../../global/api";
import { connect } from "react-redux";
import { deleteCoupons, updateCoupons } from "./Coupons.action";
import { setHeading } from "../../../accounts/account.actions";
import MaterialTable from "material-table";


const ViewCoupons = (props) => {
  const permissions = JSON.parse(window.localStorage.getItem("permissions"));
  const Checkpermissions = (permissionsType, permissionsName) => {
    return permissions.some((p) => p[`${permissionsType}`] === permissionsName) ? false : true;
  };

  useEffect(() => {
    props.setHeading("Coupon List");
  }, []);

  return (
    <>
      <Container fluid>
        <MaterialTable
          title="Coupons List"
          columns={[
            { title: "Coupon Name", field: "name" },
            { title: "Coupon Amount", field: "amount" },
            { title: "Coupon Code", field: "code" },
            { title: "Coupon Type", field: "type", editable: "never" },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = `${baseURL}/coupons?`;
              url += "limit=" + query.pageSize;
              url += "&page=" + query.page;
              url += "&search=" + query.search;
              fetch(url, {
                method: "GET",
                headers: headers,
              }).then((response) => response.json()).then((result) => {
                resolve({
                  data: result.data,
                  page: result.page,
                  totalCount: result.total_results,
                });
              });
            })
          }
          options={{
            actionsColumnIndex: -1,
            exportButton: true,
            exportAllData: true,
            paging: true,
            pageSize: 50,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [50, 100, 150, 200],
            headerStyle: {
              position: "sticky",
              top: 0,
              color: "#00BBBB",
              fontWeight: "550",
              onRowAdd: "none",
              whiteSpace: 'nowrap',
            },
            rowStyle: {
              whiteSpace: 'nowrap',
            },
            cellStyle: {
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
          }}
          editable={{
            isEditHidden: (rowData) => Checkpermissions("permissionsSubCatName", "Coupon Edit"),
            isDeleteHidden: (rowData) => Checkpermissions("permissionsSubCatName", "Coupon Delete"),
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  props.updateCoupons(newData, oldData);
                  resolve();
                }, 600);
              }),
            onRowDelete: (oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  props.deleteCoupons(oldData._id);
                  resolve();
                }, 600);
              }),
          }}
        />
      </Container>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateCoupons: (newData, oldData) => dispatch(updateCoupons(newData, oldData)),
    deleteCoupons: (_Id) => dispatch(deleteCoupons(_Id)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ViewCoupons);